
 // intermediate
 import inter from "../assets/intermediate/ChatGPT Image Jul 31, 2025, 12_36_50 AM.png"
 import inter2 from "../assets/intermediate/mpc.png"

 import inter4 from "../assets/academics/Modern-Classroom-with-Smart-Learning-System.png"
 import inter5 from "../assets/academics/CelebratingAcademicExcellenceatRankridge.png"

 
//inter slider

 import slide1 from "../assets/intermediate/toptier.png"
 import slide2 from "../assets/intermediate/stress.png"
 import slide3 from "../assets/intermediate/yourfuture.png"
import slide4 from "../assets/intermediate/proven.png"

 // mpc with IIT jee
 import mpc from "../assets/mpc/bipc.png"
 import mpc2 from "../assets/mpc/eamcet.png"
 import mpc3 from "../assets/mpc/iitjeedoubts.png"
 import mpc4 from "../assets/mpc/mpc.png"
import mpc5 from "../assets/mpc/photo1.png"
 import mpc6 from "../assets/mpc/physics.png"

 // BIPC with NEET
 import bipc from "../assets/bipcwithneet/ChatGPT Image Jul 30, 2025, 11_02_09 PM.png"
 import bipc2 from "../assets/bipcwithneet/bipc3.png"
 import bipc3 from "../assets/bipcwithneet/mpc2.png"
 import bipc4 from "../assets/bipcwithneet/photo6.png"
import bipc5 from "../assets/bipcwithneet/physicslab.png"
 import bipc6 from "../assets/bipcwithneet/production.png"
 import bipc7 from "../assets/bipcwithneet/biology.png"
//EAMCET 
 import eamcet from "../assets/emcet/eamcetcrosscourse.png"
 import eamcet2 from "../assets/emcet/teaching.png"
 import eamcet3 from "../assets/emcet/exam.png"
 import eamcet4 from "../assets/emcet/photo7.png"

 // short term
 import Shortterm  from '../assets/shortterms/examtest.png'
  import Shortterm1  from '../assets/shortterms/examtest.png'
 import Shortterm2 from '../assets/shortterms/magnet.png'
 import Shortterm3  from '../assets/shortterms/rankridge.png'

import Shortterm5  from '../assets/shortterms/shortterm.png'
//  import Shortterm1  from '../assets/photos/ChatGPT Image Jul 31, 2025, 02_07_50 AM.png'
//  import Shortterm2 from '../assets/photos/ChatGPT Image Jul 31, 2025, 12_02_39 AM.png'
//  import Shortterm3  from '../assets/photos/ChatGPT Image Jul 31, 2025, 12_43_52 AM.png'


 
 //Long Term With IIT_JEE
import longterm  from '../assets/iitjee/ChatGPT Image Jul 31, 2025, 02_50_15 AM.png'
import longterm2  from '../assets/iitjee/integration.png'
import longterm3  from '../assets/iitjee/jee.png'
import longterm4 from '../assets/iitjee/rankiniitjee.png'


//about 
 import tradition from '../assets/about/focus.png'
 import environment from '../assets/about/global-learning-in-action.png'
import about4 from "../assets/about/about.png"
import about5 from "../assets/about/legacyinspirition.png"
import neet134 from "../assets/about/neet.png"
import iit from "../assets/about/iit-jee.png"
//admissions 
 import open from '../assets/admissions/open.webp'

 import flexible from '../assets/admissions/flexible.webp'
 import stepone from '../assets/admissions/stepone.png'

//events 
 import anual from '../assets/events/celebrate.png'
 import exp from '../assets/events/exbition.png'
 import achivers from '../assets/events/achievers.png'

//studentlife 

 import everyday from '../assets/events/everyday.webp'
 import studentlife from '../assets/events/studentlife.png'
 import neverstop from '../assets/events/neverstop.png'
 import games from '../assets/events/games.png'


import jee14 from '../assets/ranks/rankridge-iit-jee-14.webp'
import jee23 from '../assets/ranks/rankridge-iit-jee-23.webp'
import jee37 from '../assets/ranks/rankridge-iit-jee-37.webp'
import jee39 from '../assets/ranks/rankridge-iit-jee-39.webp'
import jee45 from '../assets/ranks/rankridge-iit-jee-45.webp'
import jee48 from '../assets/ranks/rankridge-iit-jee-48.webp'
import jee50 from '../assets/ranks/rankridge-iit-jee-50.webp'
import jee52 from '../assets/ranks/rankridge-iit-jee-52.webp'
import jee59 from '../assets/ranks/rankridge-iit-jee-59.webp'
import jee64 from '../assets/ranks/rankridge-iit-jee-64.webp'
import jee66 from '../assets/ranks/rankridge-iit-jee-66.webp'
import jee68 from '../assets/ranks/rankridge-iit-jee-68.webp'
import jee70 from '../assets/ranks/rankridge-iit-jee-70.webp'
import jee74 from '../assets/ranks/rankridge-iit-jee-74.webp'
import jee77 from '../assets/ranks/rankridge-iit-jee-77.webp'
import jee83 from '../assets/ranks/rankridge-iit-jee-83.webp'
import jee89 from '../assets/ranks/rankridge-iit-jee-89.webp'
import jee95 from '../assets/ranks/rankridge-iit-jee-95.webp'
import neet2 from '../assets/ranks/rankridge-neet-24.webp'     // Tanisha (AIR 2)
import neet18 from '../assets/ranks/rankridge-neet-18.webp'    // Yusuf (AIR 18)
import neet62 from '../assets/ranks/rankridge-neet-62.webp'    // Raghav (AIR 62)
import neet69 from '../assets/ranks/rankridge-neet-69.webp'    // P. Nolebia (AIR 69)
import neet73 from '../assets/ranks/rankridge-neet-73.webp'    // Hansik (AIR 73)
import neet79 from '../assets/ranks/rankridge-neet-79.webp'    // Saher Afzar (AIR 79)
import neet142 from '../assets/ranks/rankridge-neet-142.webp'  // Purnima (AIR 142)
import neet295 from '../assets/ranks/rankridge-neet-295.webp'  // Shiela (AIR 295)
import neet578 from '../assets/ranks/rankridge-neet-578.webp'  // Ujjwal Reddy (AIR 578)
import neet601 from '../assets/ranks/rankridge-neet-601.webp'  // Deekshitha (AIR 601)
import neet692 from '../assets/ranks/rankridge-neet-692.webp'  // M. Yaswanth Reddy (AIR 692)
import neet796 from '../assets/ranks/rankridge-neet-796.webp'  // Sahithi (AIR 796)
import neet872 from '../assets/ranks/rankridge-neet-872.webp'  // Sureshno Sai (AIR 872)
import neet937 from '../assets/ranks/rankridge-neet-937.webp'  // Ashitha Jyothi (AIR 937)
 
import rankridgebatmation from "../assets/rankridgeimages/rankridge-batmation.webp"
import rankridgecricket   from '../assets/rankridgeimages/rankridge-cricket.webp'
import rankridgejeemains2025successcelbration01 from '../assets/rankridgeimages/rankridge-jee-mains-2025-success-celbration-01.webp'
import rankridgejeemains2025successcelbration02   from '../assets/rankridgeimages/rankridge-jee-mains-2025-success-celbration-02.webp'
import rankridgejeemains2025successcelbration03 from '../assets/rankridgeimages/rankridge-jee-mains-2025-success-celbration-03.webp'
import rankridgejeemains2025successcelbration04 from '../assets/rankridgeimages/rankridge-jee-mains-2025-success-celbration-04.webp'
 import rankridgejeemains2025successcelbrationgirlsimage   from '../assets/rankridgeimages/rankridge-jee-mains-2025-success-celbration-girls-image.webp'
import rankridgejeemains2025successcelbration   from '../assets/rankridgeimages/rankridge-jee-mains-2025-success-celbration.webp'
import rankridgesports from '../assets/rankridgeimages/rankridge-sports.webp'
import rankridgevallyball from '../assets/rankridgeimages/rankridge-vallyball.webp'

//neet images
import neet1 from '../assets/neet/bipc2.png'
  import neetn2 from '../assets/neet/modelphysics.png'
  import  neet3 from '../assets/neet/photo2.png'
 import  neet4 from '../assets/neet/principle.png'
export const successImages=[rankridgebatmation,rankridgecricket,rankridgejeemains2025successcelbration01,
  rankridgejeemains2025successcelbration02,
  rankridgejeemains2025successcelbration03,
  rankridgejeemains2025successcelbration04,
  rankridgejeemains2025successcelbrationgirlsimage,
  rankridgejeemains2025successcelbration,
 
  rankridgesports,
  rankridgevallyball

 ]

 export const acadmicImages = [
 inter,
  inter2,
  inter4,
    inter5,
];


export const homeImages = [
    // empower,
 rankridgejeemains2025successcelbration02,
   rankridgebatmation,rankridgecricket,
   
  rankridgejeemains2025successcelbration03,
  
 
  rankridgesports,
  rankridgevallyball,

];
//neet 
export const neetImages=[
  neet1,
  neetn2,
  neet3,
  neet4
]

export const aboutImages = [
  
  tradition,
  environment,
  about4,neet134,iit
];



export const AdmissionsImages = [
  stepone,
 open,
 flexible
];

export const studentLifeImages = [
  everyday, 
  studentlife,
  neverstop,
  games
];
export const interStudents=[

]

export const eventImages = [
anual,
exp,
achivers
];

export const longtermCourse= [
longterm,
longterm2,
longterm3,
longterm4,
]

 export const ShorttermCourse =[
  Shortterm,
  Shortterm1,
  Shortterm2,
  Shortterm3,
  Shortterm5
 ]

 export const eamcetCourse =[
  eamcet,
  eamcet2,
  eamcet3,
  eamcet4,
 ]

 export const bipcwithneet =[
 bipc,
 bipc2,
 bipc3,
 bipc4,
 bipc5,
 bipc6,
 ]

 export const mpcwithiit =[
 mpc,
  mpc2,
   mpc3,
    mpc4,
     mpc5,
    mpc6
 ]

 export const neetRankImages = [
  neet2,     // Tanisha (AIR 2)
  neet18,    // Yusuf (AIR 18)
  neet62,    // Raghav (AIR 62)
  neet69,    // P. Nolebia (AIR 69)
  neet73,    // Hansik (AIR 73)
  neet79,    // Saher Afzar (AIR 79)
  neet142,   // Purnima (AIR 142)
  neet295,   // Shiela (AIR 295)
  neet578,   // Ujjwal Reddy (AIR 578)
  neet601,   // Deekshitha (AIR 601)
  neet692,   // M. Yaswanth Reddy (AIR 692)
  neet796,   // Sahithi (AIR 796)
  neet872,   // Sureshno Sai (AIR 872)
  neet937,    // Ashitha Jyothi (AIR 937)
   jee14,
  jee23,
  jee37,
  jee39,
  jee45,
  jee48,
  jee50,
  jee52,
  jee59,
  jee64,
  jee66,
  jee68,
  jee70,
  jee74,
  jee77,
  jee83,
  jee89,
  jee95
];
//inter slider
export const interslider=[
  slide1,
  slide2,
  slide3,
  slide4
 ]

export const jeeRanks=[ jee14,
  jee23,
  jee37,
  jee39,
  jee45,
  jee48,
  jee50,
  jee52,
  jee59,
  jee64,
  jee66,
  jee68,
  jee70,
  jee74,
  jee77,
  jee83,
  jee89,
  jee95]

  export const studentsRanks=[neet2,     // Tanisha (AIR 2)
jee14,
neet18,    // Yusuf (AIR 18)
jee23,
neet62,    // Raghav (AIR 62)
jee37,
neet69,    // P. Nolebia (AIR 69)
jee39,
neet73,    // Hansik (AIR 73)
jee45,
neet79,    // Saher Afzar (AIR 79)
jee48,
neet142,   // Purnima (AIR 142)
jee50,
neet295,   // Shiela (AIR 295)
jee52,
neet578,   // Ujjwal Reddy (AIR 578)
jee59,
neet601,   // Deekshitha (AIR 601)
jee64,
neet692,   // M. Yaswanth Reddy (AIR 692)
jee66,
neet796,   // Sahithi (AIR 796)
jee68,
neet872,   // Sureshno Sai (AIR 872)
jee70,
neet937,   // Ashitha Jyothi (AIR 937)
jee74,
           // JEE extras continue below
jee77,
jee83,
jee89,
jee95
]